/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useContext } from "react";
import fetchHelper from "../../services/fetchHelper";
import { LayoutContext } from "../../components/layout";
import { dateFormatForArrays } from "../../utils/helpers";
import "./AllReports.css";

const EditDate = ({ value, patientId, type }) => {
  const [date, setDate] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [rmonitoring, setRmonitoring] = useState(null);
  const { headerDetails, updateHeaderDetails } = useContext(LayoutContext);
  const fetchRmonitoring = async () => {
    try {
      setEditMode(true);
      const data = await fetchHelper.get({
        url: `/patientmanagement/rest/rmonitoring/findByPatientId/${patientId}`,
      });
      setRmonitoring(data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const onSave = async () => {
    try {
      setIsLoading(true);
      await fetchHelper.put(`/patientmanagement/rest/rmonitoring/${rmonitoring.id}`, {
        [type]: date,
        id: rmonitoring.id,
        device: rmonitoring.device,
      });
      setEditMode(false);
      setDate(dateFormatForArrays(date.split("-")));
      headerDetailsUpdate();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const headerDetailsUpdate = () => {
    let newType;
    {
      type == "poauthTh"
        ? (newType = "remoteMonitoring30CyclePreAuth")
        : (newType = "remoteMonitoring90CyclePreAuth");
    }
    const patientIndex = headerDetails.findIndex((item) => item?.id == patientId);
    const updatedObject = { ...headerDetails[patientIndex], [newType]: date };
    const headerDetailsCopy = [...headerDetails];
    headerDetailsCopy.splice(patientIndex, 1, updatedObject);
    updateHeaderDetails(headerDetailsCopy);
  };

  return (
    <>
      {editMode ? (
        <div className="edit-container">
          <input
            type="date"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
          <button className="btn btnSuccess edit-buttons" onClick={onSave}>
            {isLoading ? (
              <div id="results-loading-icon" className="saving-white-ico icon-64 edit-loading" />
            ) : (
              <div className="check-flat-ico icon-64 edit-loaded" />
            )}
          </button>
          <button className="btn btn-urgent edit-buttons" onClick={() => setEditMode(false)}>
            <div className="close-flat-ico icon-64 cancel-icon" />
          </button>
        </div>
      ) : (
        <div className="edit-option">
          {date}
          <div className="icon-64 pencil-gray-icon edit-pencil-icon" onClick={fetchRmonitoring} />
        </div>
      )}
    </>
  );
};
export default EditDate;
